export var DEFAULT_TEXTS = {
    all: 'All',
    none: 'None',
    cancel: 'Cancel',
    apply: 'Apply'
};
//# sourceMappingURL=helpers.js.map